<template>
  <page-header>
    <template v-slot:title> Pomp opdracht </template>
  </page-header>
  <div class="pump-assignment-card -mt-32">
    <div class="mx-auto w-10/12 pb-12">
      <div class="rounded-lg py-6">
        <div class="pumpMaintenanceRow grid grid-col-12 pb-8">
          <card>
            <template v-slot>
              <div class="pt-4 pb-6">
                <label for="txtSearchPump" class="block leading-6 text-black font-bold text-base">Zoek pomp</label>
                <div class="grid grid-cols-2 my-2">
                  <div class="col-span-2">
                    <div class="flex">
                      <input
                        type="text"
                        name="txtSearchPump"
                        id="txtSearchPump"
                        class="w-60 h-10 px-4 rounded border border-gray-400 py-1.5 text-black placeholder:text-gray-400 sm:text-base sm:leading-6"
                        placeholder="Soort pomp of serienummer"
                      />
                      <button
                        type="button"
                        @click="searchPump()"
                        class="inline-flex items-center gap-x-2 ml-3.5 rounded-md bg-pdsPrimaryColor w-32 h-10 p-3 pl-6 text-base font-bold text-white border-0"
                      >
                        Zoeken <v-search-icon class="-mr-0.5 w-6 h-6" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <span class="text-2xl font-semibold leading-6 flex-1 mx-2">Pompen</span>
              <!-- Available Pumps -->
              <div
                v-if="
                  isOwnPumps == true && computedAvailablePumps.pumpList && computedAvailablePumps.pumpList.length > 0
                "
              >
                <div class="max-h-96 w-11/12 mb-6 overflow-y-auto overflow-x-hidden">
                  <ul role="list" class="mt-4 mb-4 border-t-2 border-gray-300">
                    <li
                      v-for="(row, index) in computedAvailablePumps.pumpList"
                      :key="index"
                      class="flex gap-x-8 py-5 border-b-2 border-gray-300 cursor-pointer"
                      @click="selectPump(index, row)"
                    >
                      <div class="flex w-3/5 gap-x-8 ml-10">
                        <span class="mt-2.5">
                          <img class="h-12 w-12 flex-none rounded-full bg-gray-50" :src="row.imageURL" alt="" />
                        </span>
                        <div class="w-80 flex-auto ml-4">
                          <p class="mb-1 text-base font-semibold leading-6 text-gray-900">{{ row.pumpDesc }}</p>
                          <span class="text-sm truncate text-xs leading-5 text-gray-500">
                            {{ row.serialNo }} &nbsp;&nbsp;
                            <span v-if="row.daysLeftForMaintenance == null">Onbekend</span>
                            <span v-else>{{ 'Onderhoud in ' + row.daysLeftForMaintenance + ' dagen' }}</span>
                            <!-- {{ getStatusField(row.equipmentStatus, row.lendoutWarehouseId) }} -->
                          </span>
                        </div>
                      </div>
                      <div class="pt-2 mr-10">
                        <button
                          type="button"
                         :class="{ 'bg-pdsPrimaryColor': isSelected[index], 'bg-white': !isSelected[index] }"
                          class="text-center align-middle w-64 h-10 rounded-full border border-pdsPrimaryColor w-32 h-10 text-base font-bold"
                        >
                          <span :class="{ 'text-white': isSelected[index] }" class="text-pdsPrimaryColor">{{
                            isSelected[index] ? 'Pomp gekozen' : 'Kies deze pomp'
                          }}</span>
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- Mediq Depot Pumps -->
              <div v-else-if="isOwnPumps == false && additionalPumps && additionalPumps.length > 0">
                <div class="max-h-96 w-11/12 mb-6 overflow-y-auto overflow-x-hidden">
                  <ul role="list" class="mt-4 mb-4 border-t-2 border-gray-300">
                    <li
                      v-for="(row, index) in additionalPumps"
                      :key="index"
                      class="flex gap-x-8 py-5 border-b-2 border-gray-300 cursor-pointer"
                      @click="selectPump(index, row)"
                    >
                      <div class="flex w-3/5 gap-x-8 ml-10">
                        <span class="mt-2.5">
                          <img class="h-12 w-12 flex-none rounded-full bg-gray-50" :src="row.imageURL" alt="" />
                        </span>
                        <div class="w-80 flex-auto ml-4">
                          <p class="mb-1 text-base font-semibold leading-6 text-gray-900">{{ row.pumpDesc }}</p>
                          <span class="text-sm truncate text-xs leading-5 text-gray-500">
                            <!-- {{getStatusField(row.equipmentStatus,row.lendoutWarehouseId) }} &nbsp;&nbsp; -->
                            <span v-if="row.daysLeftForMaintenance == null">Onbekend</span>
                            <span v-else>{{ 'Onderhoud in ' + row.daysLeftForMaintenance + ' dagen' }}</span>
                          </span>
                        </div>
                      </div>
                      <div class="pt-2 mr-10">
                        <button
                          type="button"
                          :class="{ 'bg-pdsPrimaryColor': isSelected[index], 'bg-white': !isSelected[index] }"
                          class="text-center align-middle w-64 h-10 rounded-full border border-pdsPrimaryColor w-32 h-10 text-base font-bold"
                        >
                          <span :class="{ 'text-white': isSelected[index] }" class="text-pdsPrimaryColor">{{
                            isSelected[index] ? 'Pomp gekozen' : 'Kies deze pomp'
                          }}</span>
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- No Pumps Warning! -->
              <div v-else-if="patientPumpConfiguration" class="pump-assignment__no-pumps">
                <v-table>
                  <thead>
                    <!-- <tr class="pump-assignment__no-pumps__cell_thead">
                      <th />
                    </tr> -->
                  </thead>
                  <tr>
                    <td class="pump-assignment__no-pumps__cell_data">
                      <v-warning-message
                        :warning="patientPumpConfiguration.noPumpWarning"
                        :message="patientPumpConfiguration.noPumpMessage"
                        :html="false"
                        :is-urgent="false"
                      />
                    </td>
                  </tr>
                </v-table>
              </div>

              <div class="mb-5 mr-20">
                <a
                  class="text-black font-normal text-lg underline cursor-pointer flex justify-end"
                  @click="getAdditionalPumps(isOwnPumps)"
                >
                  {{ isOwnPumps ? 'Pomp uit Mediq depot selecteren' : 'Pomp uit eigen depot selecteren' }}
                </a>
              </div>

              <!-- Starting packages -->
              <div class="pt-2.5" v-if="startingPackages && startingPackages.length > 0">
                <span class="text-2xl font-semibold leading-6 flex-1 mx-2">Startpakketten</span>
                <div class="max-h-96 w-11/12 mb-6 overflow-y-auto overflow-x-hidden">
                  <ul role="list" class="mt-4 mb-4 border-t-2 border-gray-300">
                    <li class="flex gap-x-8 py-5 border-b-2 border-gray-300 cursor-pointer"
                    >
                      <div class="flex w-3/5 gap-x-8 ml-10">
                        <span class="mt-2.5">
                          <img class="h-12 w-12 flex-none rounded-full bg-gray-50"
                            src="@/static/img/no-startingpackage-image.png" alt="" />
                        </span>
                        <div class="w-80 flex-auto ml-4">
                          <p class="mb-1 text-base font-semibold leading-6 text-gray-900">Ik wil geen startpakket
                            aanvragen bij deze pomp</p>
                        </div>
                      </div>
                      <div class="pt-2 mr-10">
                        <button type="button" @click="setNoStartingPackage"
                          class="text-center align-middle w-64 h-10 rounded-full border border-pdsPrimaryColor w-32 h-10 text-base font-bold"
                         :class="isNoStartingPackageOptionSelected ? 'bg-pdsPrimaryColor' : 'bg-white'">
                          <span :class="!isNoStartingPackageOptionSelected ? 'text-pdsPrimaryColor' : 'text-white'">
                           Geen startpakket inzetten
                          </span>
                        </button>
                      </div>
                    </li>
                    <li
                      v-for="(row, index) in startingPackages"
                      :key="index"
                      class="flex gap-x-8 py-5 border-b-2 border-gray-300 cursor-pointer"
                      @click="selectProduct(index, row)"
                    >
                      <div class="flex w-3/5 gap-x-8 ml-10">
                        <span class="mt-2.5">
                          <img class="h-12 w-12 flex-none rounded-full bg-gray-50" :src="row.imageURL" alt="" />
                        </span>
                        <div class="w-80 flex-auto ml-4">
                          <p class="mb-1 text-base font-semibold leading-6 text-gray-900">{{ row.pumpDesc }}</p>
                          <span class="text-sm truncate text-xs leading-5 text-gray-500">
                            {{ row.productCode }}
                          </span>
                        </div>
                      </div>
                      <div class="pt-2 mr-10">
                        <button
                          type="button"
                         :class="{ 'bg-pdsPrimaryColor': isPackageSelected[index], 'bg-white': !isPackageSelected[index]}"
                          class="text-center align-middle w-64 h-10 rounded-full border border-pdsPrimaryColor w-32 h-10 text-base font-bold"
                        >
                          <span :class="{ 'text-white': isPackageSelected[index] , 'text-pdsPrimaryColor' :!isPackageSelected[index]}" class="text-pdsPrimaryColor">{{
                            isPackageSelected[index] ? 'Pakket gekozen' : 'Kies dit pakket'
                          }}</span>
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Starting packages Question -->
              <div class="pt-4 pb-4 font-normal text-base text-black" v-if="showPackageDeliveryDetails">
                <legend class="font-semibold leading-6 pb-4">Zijn de producten meegegeven aan de patiënt? *</legend>
                <div class="flex items-center pb-2">
                  <input
                    id="ForPatient"
                    name="packageDeliveryOptions"
                    type="radio"
                    @change="packageDeliveryOptionSelect"
                    class="h-6 w-4 border-gray-300 text-pdsPrimaryColor accent-pdsPrimaryColor focus:ring-pdsPrimaryColor"
                  />
                  <label for="ForPatient" class="ml-3 block font-normal leading-6">Ja</label>
                </div>
                <div class="flex items-center pb-2">
                  <input
                    id="ForClient"
                    name="packageDeliveryOptions"
                    type="radio"
                    @change="packageDeliveryOptionSelect"
                    class="h-6 w-4 border-gray-300 text-pdsPrimaryColor accent-pdsPrimaryColor focus:ring-pdsPrimaryColor"
                  />
                  <label for="ForClient" class="ml-3 block font-normal leading-6">Nee</label>
                </div>
                <div class="form-group-simple__details" v-if="showPackageDeliveryError">
                  <div class="form-group-simple__messages">
                    <div class="form-group-simple__error">
                      <span> <v-error-icon></v-error-icon> Dit veld is verplicht.</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pt-4 pb-6 font-normal text-base text-black" v-if="showDeliveryDetails">
                <legend class="font-semibold leading-6 pb-4">Wanneer moet Mediq de pomp leveren? *</legend>
                <div class="flex items-center pb-2">
                  <input
                    id="TodayWithinFourHours"
                    name="deliveryOptions"
                    type="radio"
                    @change="deliveryOptionSelect"
                    class="h-6 w-4 border-gray-300 text-pdsPrimaryColor accent-pdsPrimaryColor focus:ring-pdsPrimaryColor"
                  />
                  <label for="TodayWithinFourHours" class="ml-3 block font-normal leading-6">
                    Vandaag (binnen 4 uur)
                  </label>
                </div>
                <div class="flex items-center pb-2">
                  <input
                    id="TomorrowBeforeTwelve"
                    name="deliveryOptions"
                    type="radio"
                    @change="deliveryOptionSelect"
                    class="h-6 w-4 border-gray-300 text-pdsPrimaryColor accent-pdsPrimaryColor focus:ring-pdsPrimaryColor"
                  />
                  <label for="TomorrowBeforeTwelve" class="ml-3 block font-normal leading-6">
                    Morgen (vóór 12:00 uur)
                  </label>
                </div>
                <div class="flex items-center pb-2">
                  <input
                    id="Other"
                    name="deliveryOptions"
                    type="radio"
                    @change="deliveryOptionSelect"
                    class="h-6 w-4 border-gray-300 text-pdsPrimaryColor accent-pdsPrimaryColor focus:ring-pdsPrimaryColor"
                  />
                  <label for="Other" class="ml-3 block font-normal leading-6">Anders, namelijk:</label>
                </div>
                <div v-if="showDeliveryDate" class="font-normal text-base text-black">
                  <legend class="font-semibold leading-6 pb-2">Datum</legend>
                  <div>
                    <v-input-date-picker
                      class="w-1/5"
                      ref="deliveryDate"
                      type="date"
                      name="deliveryDate"
                      label=""
                      autofocus
                      custom-date-range
                      @selected="handleDeliveryDate"
                    />
                  </div>
                </div>
                <div class="form-group-simple__details" v-if="showLeveringError">
                  <div class="form-group-simple__messages">
                    <div class="form-group-simple__error">
                      <span> <v-error-icon></v-error-icon> Dit veld is verplicht.</span>
                    </div>
                  </div>
                </div>

                <div class="w-11/12 flex pt-6 pb-4">
                  <div class="w-2/5">
                    <legend class="font-semibold leading-6 pb-4">Gewenste afleverlocatie</legend>
                    <div class="flex items-center pb-2">
                      <input
                        id="homeAddress"
                        name="deliveryLocation"
                        type="radio"
                        checked
                        @change="deliveryLocationSelect"
                        class="h-6 w-4 border-gray-300 text-pdsPrimaryColor accent-pdsPrimaryColor focus:ring-pdsPrimaryColor"
                      />
                      <label for="homeAddress" class="ml-3 block font-normal leading-6">Woonadres</label>
                    </div>
                    <div v-if="deliveryAddress && deliveryAddress.AdresId !== 0" class="flex items-center pb-2">
                      <input
                        id="deliveryAddress"
                        name="deliveryLocation"
                        type="radio"
                        @change="deliveryLocationSelect"
                        class="h-6 w-4 border-gray-300 text-pdsPrimaryColor accent-pdsPrimaryColor focus:ring-pdsPrimaryColor"
                      />
                      <label for="deliveryAddress" class="ml-3 block font-normal leading-6">
                        Afwijkend afleveradres
                      </label>
                    </div>
                    <div class="flex items-center pb-2">
                      <input
                        id="differentAddress"
                        name="deliveryLocation"
                        type="radio"
                        @change="deliveryLocationSelect"
                        class="h-6 w-4 border-gray-300 text-pdsPrimaryColor accent-pdsPrimaryColor focus:ring-pdsPrimaryColor"
                      />
                      <label for="differentAddress" class="ml-3 block font-normal leading-6">
                        Eenmalig afwijkend afleveradres
                      </label>
                    </div>
                  </div>
                  <div class="w-2/5">
                    <legend class="font-semibold leading-6 pb-4">Afleveradres</legend>
                    <div v-if="showHomeAddress" class="flex items-center pb-2 block text-sm font-normal leading-6">
                      {{ homeAddress.Straatnaam }} {{ homeAddress.Huisnummer }} {{ homeAddress.Toevoeging }} <br />
                      {{ homeAddress.Postcode }} {{ homeAddress.Woonplaats }}<br />
                      {{ homeAddress.Land }}
                    </div>
                    <div v-if="showDeliveryAddress && deliveryAddress && deliveryAddress.AdresId !== 0">
                      {{ deliveryAddress.Straatnaam }} {{ deliveryAddress.Huisnummer }}
                      {{ deliveryAddress.Toevoeging }} <br />
                      <span class="mb-1">{{ deliveryAddress.Postcode }} {{ deliveryAddress.Woonplaats }}</span> <br />
                      <span>{{ deliveryAddress.Land }}</span>
                    </div>

                    <div class="grid grid-rows-1 my-2 w-3/4" v-if="showAddressDetails">
                      <div class="grid grid-cols-2 gap-2">
                        <div class="flex items-center px-2 py-2 col">
                          <div class="col w-full">
                            <v-input-group-simple-2
                              id="Postcode"
                              v-model="differentAddress.Postcode"
                              type="text"
                              maxlength="7"
                              :rules="{
                                required: true,
                                regex: /^[1-9][0-9]{3} ?(?!sa|sd|ss)[a-z]{2}$/i
                              }"
                              label="Postcode"
                              @blur="autoFillAddress()"
                            />
                          </div>
                        </div>
                        <div class="flex items-center px-2 py-2 col">
                          <div class="col w-full">
                            <v-input-group-simple-2
                              id="Huisnummer"
                              v-model="differentAddress.Huisnummer"
                              type="text"
                              :rules="{
                                required: true
                              }"
                              label="Huisnummer"
                              @blur="autoFillAddress()"
                            />
                          </div>
                        </div>
                        <div class="flex items-center px-2 py-2 col-span-2">
                          <div class="w-full">
                            <v-input-group-simple-2
                              id="Toevoeging"
                              v-model="differentAddress.Toevoeging"
                              type="text"
                              :rules="{
                                required: false
                              }"
                              label="Toevoeging"
                            />
                          </div>
                        </div>
                        <div class="flex items-center px-2 py-2 col-span-2">
                          <div class="w-full">
                            <v-input-group-simple-2
                              id="Straatnaam"
                              :key="prefillAddressDataKey"
                              v-model:value="differentAddress.Straatnaam"
                              type="text"
                              :rules="{
                                required: true
                              }"
                              label="Straatnaam"
                              :disabled="addressLookupSuccessful"
                            />
                          </div>
                        </div>
                        <div class="flex items-center px-2 py-2 col-span-2">
                          <div class="w-full">
                            <v-input-group-simple-2
                              id="Woonplaats"
                              :key="prefillAddressDataKey"
                              v-model:value="differentAddress.Woonplaats"
                              type="text"
                              :rules="{
                                required: true
                              }"
                              label="Plaats"
                              :disabled="addressLookupSuccessful"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex items-center pb-4">
                  <v-input-group-simple-2
                    id="TelephoneNumber"
                    ref="manualTelephoneNumber"
                    v-model="manualTelephoneNumber"
                    :rules="{
                      required: true,
                      regex: /^0\d{9}$/
                    }"
                    type="text"
                    label="Telefoonnummer"
                  />
                </div>

                <div class="flex items-center pb-4 w-6/12">
                  <v-textarea-group
                    v-model="optionalText"
                    inputid="Uw bericht"
                    label="Opmerkingen (optioneel)"
                    @input="setRemark"
                  />
                </div>
              </div>

              <div class="row justify-content-end pt-4">
                <v-button md primary :class="getButtonStatus()" @click.prevent="savePump"> Toewijzen </v-button>
                <v-button md hollow transparent @click.prevent="cancelPumpAssignment"> Annuleren </v-button>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>

  <generic-modal v-if="reConfirmationPopup">
    <template #body>
      <p>
        U staat op het punt om te stoppen met het toewijzen van een pomp aan uw patiënt. Indien u op annuleren klikt
        wordt er geen pomp geleverd en komt er een actie voor pomp toewijzen op uw actielijst. Kies pomp toewijzen als u
        toch een pomp wenst toe te wijzen.
      </p>
    </template>
    <template #footer>
      <v-button md hollow transparent @click.prevent="prescriberRredirect('/patientdashboard')"> Annuleren </v-button>
      <v-button tagelement="button" md primary @click.prevent="cancelReConfirmationPopup"> Pomp toewijzen </v-button>
    </template>
  </generic-modal>

  <generic-modal v-if="showPopup">
    <template #header>
      {{ patientPumpConfiguration.popupHeader }}
    </template>
    <template #body>
      <p>{{ patientPumpConfiguration.popupText }}</p>
    </template>
    <template #footer>
      <v-button v-if="getAccountabilityFlowStatus()" md hollow transparent @click.prevent="createAccountability()">
        {{ patientPumpConfiguration.createNewAuthorizationLinkText }}
      </v-button>
      <v-button
        v-else
        md
        hollow
        transparent
        class="pump-assignment__more-pumps__cancel-pumpassignment"
        @click.prevent="prescriberRredirect('/')"
      >
        {{ patientPumpConfiguration.myDashboardLinkText }}
      </v-button>
      <v-button md primary @click.prevent="prescriberRredirect('/patientdashboard')">
        {{ patientPumpConfiguration.popupButton }}
      </v-button>
    </template>
  </generic-modal>
</template>

<script>
import moment from 'moment';
import router from '@/router';
import VTable from '@/components/shared/table/Table';
import VInputDatePicker from '@/components/shared/form/simple/InputDatePicker';
import { useStore, mapActions } from 'vuex';
import { computed, ref } from 'vue';
import GenericModal from '@/components/shared/GenericModal';
import VWarningMessage from '@/components/shared/WarningMessage';
import { router$ } from '@/router/router$';
import { useForm } from 'vee-validate';
import { from, of, combineLatest } from 'rxjs';
import { map, publishReplay, refCount, switchMap } from 'rxjs/operators';
import { getLicenseOverview, activeCustomerId$, activePpwRecId$, navigateToAccountability } from '@/services';
import VErrorIcon from 'icons/AlertCircle';
import VSearchIcon from 'icons/Magnify';

export default {
  name: 'PumpAssignment',
  components: {
    VTable,
    GenericModal,
    VWarningMessage,
    VInputDatePicker,
    VErrorIcon,
    VSearchIcon
  },
  setup() {
    const store = useStore();
    const licenseId = ref(null);
    const accountabilityId = ref(null);
    const licenseOverview = ref(null);
    const customerId = ref(null);
    const patientPumpConfiguration = ref(null);
    const availablePumps = ref([]);
    const userWarehouseId = ref(null);
    const computedAvailablePumps = ref([]);
    const isNoStartingPackageOptionSelected = ref(false);
    const  isPackageSelected =  ref([]);
    const patientGegevens = computed(() => store.getters['patient/getPatientGegevens']);
    const user = computed(() => store.getters['navigation/getUser']);
    const homeAddress = computed(() => store.getters['patient/getPatientHomeAddress']);
    const differentAddress = computed(() => store.getters['patient/getPatientDifferentAddress']);
    const deliveryAddress = computed(() => store.getters['patient/getPatientDeliveryAddress']);

    const saveAllocatePump = (value) => store.dispatch('patient/saveAllocatePump', value);
    const allocatePumpFromMediqDepot = (value) => store.dispatch('patient/allocatePumpFromMediqDepot', value);
    const getAdditionalPumpsStore = (value) => store.dispatch('patient/getAdditionalPumps', value);
    const setShowExtendLicensesBlock = (value) => store.commit('accountability/setShowExtendLicensesBlock', value);
    const fetchAddressLookup = (value) => store.dispatch('patient/fetchAddressLookup', value);
    const getStartingPackagesStore = (value) => store.dispatch('patient/getStartingPackages', value);

    const licenseId$ = router$.pipe(map((route) => route && route.params.licenseId / 1));

    const customerId$ = activeCustomerId$;

    const licenseOverview$ = combineLatest([customerId$, activePpwRecId$, licenseId$]).pipe(
      switchMap(([customerId, ppwRecId, licenseId]) => {
        return licenseId && ppwRecId && customerId
          ? from(getLicenseOverview(customerId, ppwRecId, licenseId))
          : of(null);
      }),
      publishReplay(1),
      refCount()
    );

    const accountabilityId$ = licenseOverview$.pipe(map((license) => (license ? license.accountabilityId : null)));

    licenseId$.subscribe((id) => {
      licenseId.value = id;
    });

    accountabilityId$.subscribe((id) => {
      accountabilityId.value = id;
    });

    licenseOverview$.subscribe((overview) => {
      licenseOverview.value = overview;
    });

    customerId$.subscribe((id) => {
      customerId.value = id;
    });

    store.dispatch('patient/fetchPatientAddress', customerId.value);
    store.dispatch('patient/fetchPatientPumpConfiguration').then((response) => {
      patientPumpConfiguration.value = response.data;
    });
    let requiredIds = {
      Status: 1
    };

    const computeAvailablePumps = () => {
      computedAvailablePumps.value = Object.assign([], availablePumps.value);
      computedAvailablePumps.value.pumpList = computedAvailablePumps.value.pumpList.sort((a, b) =>
        a.pumpDesc.localeCompare(b.pumpDesc)
      );
    };

    store.dispatch('patient/fetchAvailablePumps', requiredIds).then((response) => {
      availablePumps.value = response.data;
      computeAvailablePumps();
      userWarehouseId.value = response.data.userWarehouseId;
    });
  
    const setNoStartingPackage = () => {
     isNoStartingPackageOptionSelected.value = true;
     isPackageSelected.value = [];
    };

    return {
      patientGegevens,
      user,
      homeAddress,
      differentAddress,
      deliveryAddress,
      saveAllocatePump,
      allocatePumpFromMediqDepot,
      getAdditionalPumpsStore,
      setShowExtendLicensesBlock,
      fetchAddressLookup,
      ...mapActions({
        requestAccountabilityCopy: 'accountability/requestAccountabilityCopy'
      }),
      licenseId,
      accountabilityId,
      licenseOverview,
      customerId,
      patientPumpConfiguration,
      availablePumps,
      userWarehouseId,
      computedAvailablePumps,
      computeAvailablePumps,
      getStartingPackagesStore,
      setNoStartingPackage,
      isNoStartingPackageOptionSelected,
      isPackageSelected
    };
  },
  data() {
    const { validate } = useForm();

    return {
      validate,
      pumpsHeader: ['', '', 'Omschrijving', 'Serienummer', 'Onderhoud nodig in'],
      pumpsHeadersForSorting: {
        Omschrijving: 'pumpDesc',
        Serienummer: 'serialNo',
        'Onderhoud nodig in': 'daysLeftForMaintenance'
      },
      emptyHeader: [''],
      isPumpSelected: false,
      pumpId: '',
      productId: '',
      showPopup: false,
      additionalPumps: [],
      additionalPumpSelected: false,
      serialNumber: '',
      manualTelephoneNumber: '',
      selectedOption: '',
      showManualPump_Warning: false,
      optionalText: '',
      addressLookup: null,
      prefillAddressDataKey: 0,
      selectedDeliveryOption: '',
      selectedDeliveryLocation: 'homeAddress',
      deliveryDate: null,
      showDeliveryDate: false,
      showHomeAddress: true,
      showDeliveryAddress: false,
      showDeliveryDetails: false,
      showAddressDetails: false,
      mediqPumpOptionSelected: false,
      reConfirmationPopup: false,
      showLeveringError: false,
      pumpSearchJson: {
        searchText: null,
        status: 'Toon Alles'
      },
      isSelected: [],
      isOwnPumps: true,
      validationStatus: false,
      startingPackages: [],
      selectedPackageProductIds: [],
      selectedPackageDeliveryOption: '',
      showPackageDeliveryError: false,
      showPackageDeliveryDetails: false
    };
  },
  computed: {
    serialNumberValidated() {
      if (this.selectedOption === 'manualpump' && this.serialNumber === '') {
        return false;
      }
      return true;
    },
    licenseOverviews() {
      if (!this.licenseOverview) {
        return [];
      }

      return [this.licenseOverview];
    },
    addressLookupSuccessful() {
      return this.addressLookup !== null;
    },
    deliveryDetailsValidated() {
      if (this.showDeliveryDetails == true && this.selectedDeliveryLocation !== '') {
        return true;
      }
      return false;
    }
  },
  watch: {
    selectedDeliveryOption(value) {
      if (value) {
        this.showLeveringError = false;
      }
    },
    selectedPackageDeliveryOption(value) {
      if (value) {
        this.showPackageDeliveryError = false;
      }
    },
    isNoStartingPackageOptionSelected(value) {
      if (value) {
        this.showPackageDeliveryDetails = false
        if (this.isOwnPumps === false) {
          this.showDeliveryDetails = true;
        } else {
          this.showDeliveryDetails = false;
        }
      }
    }
  },
  methods: {
    searchPump() {
      let searchText = document.getElementById('txtSearchPump').value;
      let status = searchText == '' ? '' : 'Available';
      status = this.isOwnPumps === true ? status : 'Mediq';
      let searchDetails = {
        searchText: searchText,
        status: status //'Toon Alles'
      };
      this.computeAvailablePumps();
      if (
        (!searchDetails.searchText || (searchDetails && searchDetails.searchText.length < 2)) &&
        !searchDetails.status
      ) {
        return;
      }
      if (searchDetails.searchText && searchDetails.searchText.length > 2) {
        const lowerCaseSearchText = searchDetails.searchText.toLowerCase();
        if (this.isOwnPumps === true) {
          this.computedAvailablePumps.pumpList = this.computedAvailablePumps.pumpList.filter((l) => {
            return (
              l.pumpDesc.toLowerCase().includes(lowerCaseSearchText) ||
              (l.serialNo !== null && l.serialNo.toLowerCase().includes(lowerCaseSearchText))
            );
          });
        } else {
          this.additionalPumps = this.additionalPumps.filter((l) => {
            return (
              l.pumpDesc.toLowerCase().includes(lowerCaseSearchText) ||
              (l.serialNo !== null && l.serialNo.toLowerCase().includes(lowerCaseSearchText))
            );
          });
        }
      }
      if (searchDetails.status) {
        if (this.isOwnPumps === true) {
          this.computedAvailablePumps.pumpList = this.computedAvailablePumps.pumpList.filter((l) => {
            if (searchDetails.status === 'Available') {
              return l.equipmentStatus === searchDetails.status || l.equipmentStatus === 'Lend';
            }
            if (searchDetails.status === 'Allocated') {
              return l.equipmentStatus === searchDetails.status || l.equipmentStatus === 'LendAndAssigned';
            }
            return l.equipmentStatus === searchDetails.status;
          });
        } else {
          this.additionalPumps = this.additionalPumps.filter((l) => {
            if (searchDetails.status === 'Available') {
              return l.equipmentStatus === searchDetails.status || l.equipmentStatus === 'Lend';
            }
            if (searchDetails.status === 'Allocated') {
              return l.equipmentStatus === searchDetails.status || l.equipmentStatus === 'LendAndAssigned';
            }
            return l.equipmentStatus === searchDetails.status;
          });
        }
      }
    },
    selectPump(index, data) {
      for (var i = 0; i < this.isSelected.length; i++) {
        this.isSelected[i] = false;
      }
      this.isSelected[index] = this.isSelected[index] ? false : true;

      this.pumpId = data.equipmentID;
      this.productId = data.equipmentID ? 0 : data.pumpDesc.split('-')[0];
      this.serialNumber = data.serialNo;
      if (this.isOwnPumps === false) {
        this.mediqPumpOptionSelected = true;
        this.isPumpSelected = true;
        this.showDeliveryDetails = true;
      } else {
        this.mediqPumpOptionSelected = false;
        this.isPumpSelected = true;
        this.showDeliveryDetails = false;
      }
       let relationProductId = this.pumpId == 0 ? this.productId : data.productId;

      this.isPackageSelected = [];
      this.startingPackages = [];
      this.showPackageDeliveryDetails = false;
      this.selectedPackageDeliveryOption = '';
      this.isNoStartingPackageOptionSelected = false;
      this.getStartingPackagesStore(relationProductId).then((response) => {
        this.startingPackages = response.data;
        if (this.startingPackages.length > 0) {
          this.showPackageDeliveryDetails = false;
          this.showDeliveryDetails = false
        } else {
          if (this.isOwnPumps === false) {
            this.showDeliveryDetails = true;
          } 
       }
      });
    },
    setSerialNumber(data) {
      this.serialNumber = data.serialNumber;
    },
    getButtonStatus() {
      if (this.mediqPumpOptionSelected && this.isPumpSelected && this.deliveryDetailsValidated && !this.startingPackages.length > 0) {
        return 'btn--cta';
      } else if (this.isPumpSelected && this.selectedOption !== 'mediqpump' && !this.startingPackages.length > 0) {
        return 'btn--cta';
      } else if(this.isPackageSelected.length > 0 || this.isNoStartingPackageOptionSelected == true) {
         return 'btn--cta';
      } else {
        return 'btn--disabled';
      }
    },
    async savePump() {
      if (this.mediqPumpOptionSelected && (!this.manualTelephoneNumber || !this.selectedDeliveryOption)) {
        if (!this.selectedDeliveryOption) {
          this.showLeveringError = true;
        }
        this.validate();
        return;
      }
      if (this.showPackageDeliveryDetails && !this.selectedPackageDeliveryOption) {
        this.showPackageDeliveryError = true;
        return;
      }
      await this.validateAllFields();
      if (this.validationStatus == false) {
        return;
      }
      if (this.isNoStartingPackageOptionSelected) {
        this.selectedPackageProductIds = [];
      }
      if (this.pumpId !== 0 && this.isPumpSelected) {
        let requiredDetails = {
          PatientId: this.patientGegevens.PatientId,
          PumpId: this.pumpId,
          LicenseId: this.licenseId,
          PackageDeliveryOption: this.selectedPackageDeliveryOption,
          PackageProductIds: this.selectedPackageProductIds
        };
        this.saveAllocatePump(requiredDetails).then(() => {
          this.showPopup = true;
        });
      } else if (this.isPumpSelected && this.serialNumberValidated) {
        let addressType = 0;
        let address = null;
        if (this.selectedDeliveryLocation === 'homeAddress') {
          addressType = 0;
          address = this.homeAddress;
        }
        if (this.selectedDeliveryLocation === 'deliveryAddress') {
          addressType = 1;
          address = this.deliveryAddress;
        }
        if (this.selectedDeliveryLocation === 'differentAddress') {
          addressType = 2;
          address = this.differentAddress;
        }
        let requiredDetails = {
          CustomerId: this.patientGegevens.PatientId,
          ProductId: this.productId,
          SerialNumber: this.serialNumber,
          LicenseId: this.licenseId,
          DeliveryOptions: this.selectedDeliveryOption,
          DeliveryDate: this.deliveryDate,
          AddressType: addressType,
          Address: address,
          Remark: this.optionalText,
          TelephoneNumber: this.manualTelephoneNumber,
          PackagedeliveryOption: this.selectedPackageDeliveryOption,
          PackageProductIds: this.selectedPackageProductIds
        };
        requiredDetails.DeliveryDate = requiredDetails.DeliveryDate
          ? moment(requiredDetails.DeliveryDate, 'DD-MM-YYYY').format('YYYY-MM-DD')
          : null;
        this.allocatePumpFromMediqDepot(requiredDetails).then(() => {
          this.showPopup = true;
        });
      }
    },
    getAdditionalPumps(mediqPumpsFlag) {
      this.isSelected = [];
      this.isPackageSelected = [];
      this.startingPackages = [];
      this.mediqPumpOptionSelected = false;
      this.isPumpSelected = false;
      this.showPackageDeliveryDetails = false;
      this.selectedPackageDeliveryOption = '';
      this.selectedDeliveryOption = '';
      this.selectedPackageProductIds = [];
      if (mediqPumpsFlag === false) {
        this.computeAvailablePumps();
        this.additionalPumps = [];
        this.manualTelephoneNumber = '';
        this.showManualPump_Warning = true;
        this.showDeliveryDetails = false;
        this.showHomeAddress = true;
        this.showDeliveryAddress = false;
        this.showAddressDetails = false;
      } else {
        this.computedAvailablePumps = [];
        this.serialNumber = '';
        this.showManualPump_Warning = false;
        this.getAdditionalPumpsStore(this.selectedOption).then((response) => {
          this.additionalPumps = response.data;
        });
      }
      this.isOwnPumps = !mediqPumpsFlag;
    },
    cancelPopup() {
      this.showPopup = false;
    },
    sortAdditionalPumpsByField(sortFieldDetails) {
      this.sortPumpsByField(sortFieldDetails, this.additionalPumps);
    },
    sortAvailablePumpsByField(sortFieldDetails) {
      this.sortPumpsByField(sortFieldDetails, this.computedAvailablePumps.pumpList);
    },
    sortPumpsByField(sortFieldDetails, pumpArray) {
      let key = sortFieldDetails.option;
      let value = this.pumpsHeadersForSorting[key];
      pumpArray.sort(function (a, b) {
        const leftValue = a[value];
        const rightValue = b[value];
        if (!leftValue) {
          return 1;
        }
        if (!rightValue) {
          return -1;
        }
        if (sortFieldDetails.isAscending) {
          if (typeof leftValue === 'number' && typeof rightValue === 'number') {
            return leftValue < rightValue ? -1 : 1;
          } else {
            return leftValue.localeCompare(rightValue);
          }
        } else {
          if (typeof leftValue === 'number' && typeof rightValue === 'number') {
            return leftValue > rightValue ? -1 : 1;
          } else {
            return rightValue.localeCompare(leftValue);
          }
        }
      });
    },
    createAccountability() {
      this.setShowExtendLicensesBlock(false);
      // Call the server for a new accountability, based on data of the current, 'edited' one
      this.requestAccountabilityCopy({
        AccountabilityId: this.accountabilityId,
        IsAccountabilityUsedForAssigningMultiplePumps: true
      })
        .then((response) => {
          const copyAccountabilityId = response.data.Id;
          // Request granted
          navigateToAccountability(copyAccountabilityId);
        })
        .catch((error) => {
          if (error !== 'cancel') {
            const m = error.response.data.Exception.Message;
            new Promise((resolve, reject) => {
              this.$emitter.emit('prompt', {
                title: 'Machtiging wijzigen',
                message: m,
                confirmButton: 'Naar patiënt dashboard',
                resolve,
                reject
              });
            })
              .then(() => {
                // Start a new accountability with no prefilled data. However, at the end the original still needs to be terminated!!!!!
                // TODO: when template no longer available (exception), then user needs a way to select one before starting anew
                //       the idea right now is that with the exception, backend includes a templateId property in the response in case they can
                //       determine which is the 'follow-up' template when the original is no longer valid
                //       the problem happens when backend cannot and we need to either render a template selection button in the exception overlay
                //       or we need to throw in the towel and tell the user they can't extend an accountability
                // store.dispatch('accountability/startNewAccountability', templateId).then((response) => router.push('/machtiging'))
              })
              .catch(() => {});
          }
        });
    },
    prescriberRredirect(path) {
      router.push(path);
    },
    getAccountabilityFlowStatus() {
      return router.currentRoute.value.params.type === 'verantwoording';
    },
    autoFillAddress() {
      this.fetchAddressLookup({
        postcode: this.differentAddress.Postcode,
        huisnummer: this.differentAddress.Huisnummer,
        land: 'NL'
      })
        .then((response) => {
          var hasAddress = response.data.City !== null;

          this.differentAddress.Straatnaam = hasAddress ? response.data.Street : '';
          this.differentAddress.Woonplaats = hasAddress ? response.data.City : '';
          this.differentAddress.Land = 'NL';
          this.addressLookup = hasAddress ? response.data : null;
          this.validateAllFields();
          this.prefillAddressDataKey += 1;
        })
        .catch(() => {
          this.addressLookup = null;
          this.differentAddress.Straatnaam = '';
          this.differentAddress.Woonplaats = '';
        });
    },
    async validateAllFields() {
      let result = await this.validate();
      this.validationStatus = result.valid;
    },
    deliveryOptionSelect(e) {
      this.selectedDeliveryOption = document.querySelector('input[name="' + e.currentTarget.name + '"]:checked').id;
      this.showDeliveryDate = false;
      if (this.selectedDeliveryOption === 'Other') {
        this.showDeliveryDate = true;
      }
    },
    deliveryLocationSelect(e) {
      this.selectedDeliveryLocation = document.querySelector('input[name="' + e.currentTarget.name + '"]:checked').id;
      this.showHomeAddress = false;
      this.showDeliveryAddress = false;
      this.showAddressDetails = false;
      if (this.selectedDeliveryLocation === 'homeAddress') {
        this.showHomeAddress = true;
      } else if (this.selectedDeliveryLocation === 'deliveryAddress') {
        this.showDeliveryAddress = true;
      } else {
        this.showAddressDetails = true;
      }
    },
    handleDeliveryDate(key, date) {
      this.deliveryDate = date;
    },
    setRemark(event) {
      this.optionalText = event.target ? event.target.value : '';
    },
    cancelPumpAssignment() {
      this.reConfirmationPopup = true;
    },
    cancelReConfirmationPopup() {
      this.reConfirmationPopup = false;
    },
    getStatusField(equipmentStatus, warehouseId) {
      switch (equipmentStatus) {
        case 'Allocated':
          return 'Bij patiënt';
        case 'Available':
          return 'In depot';
        case 'Lend':
          return this.userWarehouseId === warehouseId ? 'In depot, geleend' : 'Uitgeleend';
        case 'LendAndAssigned':
          return this.userWarehouseId === warehouseId ? 'Bij patient, geleend' : 'Uitgeleend en bij patient';
        case '':
          return 'Unknown';
        default:
          return equipmentStatus;
      }
    },
    selectProduct(index, data) {
      for (var i = 0; i < this.isPackageSelected.length; i++) {
        this.isPackageSelected[i] = false;
      }
      this.isPackageSelected[index] = this.isPackageSelected[index] ? false : true;
      this.selectedPackageProductIds = [];
      this.selectedPackageProductIds.push(data.productCode);
      this.showPackageDeliveryDetails = true;
      if (this.isOwnPumps === false) {
        this.showDeliveryDetails = true;
      } else {
        this.showDeliveryDetails = false;
      }
      this.isNoStartingPackageOptionSelected = false;
    },
    packageDeliveryOptionSelect(e) {
      this.selectedPackageDeliveryOption = document.querySelector(
        'input[name="' + e.currentTarget.name + '"]:checked'
      ).id;
    }
  }
};
</script>

<style lang="scss" scoped>
.pump-assignment-card {
  color: $teal-darkest;

  :deep(.form-group-simple label) {
    color: $black;
    font-weight: 700;
    font-size: 16px;
  }
}

.pump-assignment {
  .form-group-simple__error {
    .material-design-icon {
      display: inline-flex;
      width: 16px;
      height: 16px;
      fill: #eb0000;
      vertical-align: bottom;
    }
  }

  &__no-pumps {
    background-color: $table-row-background;

    &__cell_data {
      padding: 30px 500px 30px 30px;
    }

    &__cell_thead {
      height: 45px;
      border: 1px solid $gray-light;
      background-color: $teal-lighter;
    }

    &__warning_data {
      padding-top: 30px;
      padding-left: 30px;
      padding-right: 100px;
    }
  }

  &__more-pumps {
    background-color: $table-row-background;
    font-size: 16px;
    color: $black;
    padding: 30px 0 30px 0;
    margin: 24px 0px;

    &__question {
      font-weight: bold;
      padding-left: 25px;
      padding-bottom: 20px;
      text-align: start;
    }

    &__option {
      padding-top: 2px;
      padding-left: 25px;
      padding-bottom: 10px;
    }

    &__button_enable {
      background-color: $orange;
      border: $orange;
    }

    &__button_disable {
      background-color: $gray-light;
      border: $gray-light;
    }

    &__cancel-pumpassignment {
      font-size: 18px;
      color: $teal-darkest;
      padding-right: 20px;
      padding-top: 10px;
    }

    &__table {
      margin-top: 30px;
      margin-bottom: -30px;
    }
  }

  .deliveryDetails {
    margin-bottom: 24px;

    table {
      legend {
        margin: 0 0 20px;
        font-size: 16px;
        font-weight: bold;
      }

      > tr {
        > td,
        > th {
          padding: 10px 20px 16px;
        }
      }

      > tbody {
        > tr {
          > td,
          > th {
            vertical-align: baseline;
            padding: 10px 20px 16px;
            width: 33%;
            max-width: 300px;
          }
        }
      }
    }

    border: 1px solid $gray-light;
    background: $white;

    &__header {
      background-color: $grayish-very-light;
      height: 50px;
    }

    &__header_text {
      font-size: 1.266rem;
      font-weight: 300;
    }

    &__question {
      font-weight: bold;
    }

    &__option {
      color: $gray-dark;
    }
  }
}
</style>
